import { render, staticRenderFns } from "./folder_view.vue?vue&type=template&id=07166768&scoped=true&"
import script from "./folder_view.vue?vue&type=script&lang=js&"
export * from "./folder_view.vue?vue&type=script&lang=js&"
import style0 from "./folder_view.vue?vue&type=style&index=0&id=07166768&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07166768",
  null
  
)

export default component.exports